import { render, staticRenderFns } from "./Queues.vue?vue&type=template&id=416f2a57&scoped=true"
import script from "./Queues.vue?vue&type=script&lang=js"
export * from "./Queues.vue?vue&type=script&lang=js"
import style0 from "./Queues.vue?vue&type=style&index=0&id=416f2a57&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "416f2a57",
  null
  
)

export default component.exports